import Divider from '@mui/material/Divider'
import { captureMessage } from '@sentry/react'
import { SurveyDescription } from 'pages/Survey/components/SurveyDescription'
import { SurveyDropdown } from 'pages/Survey/components/SurveyDropdown'
import { SurveyHeading } from 'pages/Survey/components/SurveyHeading'
import { SurveyLikert } from 'pages/Survey/components/SurveyLikert'
import { SurveyMedia } from 'pages/Survey/components/SurveyMedia'
import { SurveyMultiChoice } from 'pages/Survey/components/SurveyMultiChoice'
import { SurveySingleChoice } from 'pages/Survey/components/SurveySingleChoice'
import { SurveyText } from 'pages/Survey/components/SurveyText'
import { SurveyTextarea } from 'pages/Survey/components/SurveyTextarea'
import { SurveyElement, surveyQuestionTypes } from 'pages/Survey/types'

type Props = {
  question: SurveyElement
}

export const Question = ({ question }: Props) => {
  switch (question.type) {
    case surveyQuestionTypes.DIVIDER:
      return <Divider sx={{ mx: 8, borderColor: (theme) => theme.palette.text.primary, mt: 1.5, mb: 2 }} />
    case surveyQuestionTypes.HEADING:
      return <SurveyHeading question={question} />
    case surveyQuestionTypes.DESCRIPTION:
      return <SurveyDescription question={question} />
    case surveyQuestionTypes.TEXT:
      return <SurveyText question={question} />
    case surveyQuestionTypes.TEXTAREA:
      return <SurveyTextarea question={question} />
    case surveyQuestionTypes.DROPDOWN:
      return <SurveyDropdown question={question} />
    case surveyQuestionTypes.SINGLE:
      return <SurveySingleChoice question={question} />
    case surveyQuestionTypes.MULTIPLE:
      return <SurveyMultiChoice question={question} />
    case surveyQuestionTypes.LIKERT:
      return <SurveyLikert question={question} />
    case surveyQuestionTypes.MEDIA:
      return <SurveyMedia question={question} />
    default:
      captureMessage(`not supported question type: ${question.type}`)
      return <div>not supported question type: {question.type}</div>
  }
}
